import { OAUTH_TOKENS_SET_LOADING, OAUTH_TOKENS_SET_TOKENS, OauthTokensPageAction } from '@Actions/oauthTokensPage';

import { IOauthAccessTokenModel } from '@Shared/models';

interface IOauthTokensState {
  loading: boolean;
  tokens: IOauthAccessTokenModel[];
}

export const defaultState: IOauthTokensState = {
  loading: true,
  tokens: []
};

export function oauthTokensPageReducer(state: IOauthTokensState = defaultState, action: OauthTokensPageAction) {
  switch (action.type) {
    case OAUTH_TOKENS_SET_LOADING:
      return { ...state, loading: action.payload };
    case OAUTH_TOKENS_SET_TOKENS:
      return { ...state, loading: false, tokens: action.payload };
    default:
      return state;
  }
}
